import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, OnInit, Inject } from '@angular/core';
import { CommonApiService } from '../../common-api.service';
import { SnackbarService } from '../../snackbar.service';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
    title: string;
    message: string;
    job_id: number;
    jobProcesses: any[] = [];
    public selectedProcess: number;
    public comment_description: string;
    allCompanies: any[] = [];
    showCompanySelection: boolean = false;
    hold_or_release: boolean = false;
    comment_required: boolean = true;
    public selectedCompany: number;
    respData: any
    repairJob : boolean
    selectedProcesses: number[] = [];

    // Status-change remark (mandatory when requireRemark = true)
    requireRemark: boolean = false;
    remarkLabel: string = 'Remark';
    remarkPlaceholder: string = 'Enter the reason for this status change';
    public statusRemark: string = '';

    constructor(
        private api: CommonApiService,
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private snackbar: SnackbarService,
    ) {
        // Update view with given values
        this.title = data.title;
        this.message = data.message;    
        this.job_id = data.job_id;
        this.repairJob = data.repairJob;
        this.showCompanySelection = data.showCompanySelection;
        this.hold_or_release = data.hold_or_release;
        this.comment_required = data.comment_required !== undefined ? data.comment_required : true;
        this.comment_description = data.comment_description;
        this.allCompanies = data.allCompanies;
        this.requireRemark = !!data.requireRemark;
        if (data.remarkLabel) this.remarkLabel = data.remarkLabel;
        if (data.remarkPlaceholder) this.remarkPlaceholder = data.remarkPlaceholder;

    }

    ngOnInit() {
        if(this.repairJob){
            this.getAllProcesses();
        }
        if (this.showCompanySelection) {
            this.api.getAll('company').subscribe(companies => {
                this.allCompanies = companies;
            })
        }
    }

    getAllProcesses() {
        this.api.callRoute('joborder', `/processes`, {'job_id': this.job_id}).subscribe( 
           (data: any) => { 
                this.jobProcesses = data;
            },
            error => {
                console.log(error)
            }
        );
    }

    onConfirm(): void {

        // if job is repair
        if (this.repairJob && this.selectedProcesses.length == 0) {
            this.snackbar.warning("Please select process");
            return;
        }

        // if job is not repair
        if (!this.repairJob){
            this.selectedProcesses = [];
        }

        if (this.hold_or_release && this.comment_required && this.comment_description == undefined) {
            this.snackbar.warning("Please enter comment");
            return;
        }
        
        if (this.allCompanies && this.allCompanies.length > 0 && this.selectedCompany == undefined) {
            this.snackbar.warning("Please select company");
            return;
        }

        if (this.requireRemark && (!this.statusRemark || !this.statusRemark.trim())) {
            this.snackbar.warning(`${this.remarkLabel} is required`);
            return;
        }

        this.respData = {
            status: true,
            repairProcess: this.selectedProcesses,
            selectedCompanyId: this.selectedCompany,
            comment_description: this.comment_description,
            remark: this.requireRemark ? this.statusRemark.trim() : undefined,
        }
    
        this.dialogRef.close(this.respData);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }

    onProcessCheckboxChange(event: any, processId: number) {
        if (event.checked) {
            this.selectedProcesses.push(processId);
        } else {
            const index = this.selectedProcesses.indexOf(processId);
            if (index > -1) {
            this.selectedProcesses.splice(index, 1);
            }
        }
    }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

    constructor(public title: string, public message: string) {
    }
}
